var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.validarVistaAdmin)?_c('Navbar',{ref:"navbar_class"}):_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.validarVistaAdmin)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }